/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Meta_DescriptionInputs */

const en_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why the Egly Method reduces golf injury risk: dissipation of force, natural follow through, and a swing built for a lifetime of play.`)
};

const es_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué el método Egly reduce el riesgo de lesiones en el golf: disipación de fuerza, seguimiento natural y un swing pensado para toda la vida.`)
};

const de_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum die Egly Method das Verletzungsrisiko im Golf senkt: Kraftverteilung, ein natürlicher Durchschwung und ein Schwung, der für ein ganzes Golferleben gebaut ist.`)
};

const zh_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么 Egly Method 能降低高尔夫受伤风险：力量消散、自然的送杆，以及为一生打球而打造的挥杆。`)
};

const ar_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لماذا يقلل منهج Egly من خطر إصابات الغولف: تبديد القوة، والمتابعة الطبيعية، وسوينغ مبني للعمر كله من اللعب.`)
};

const fr_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi l’Egly Method réduit le risque de blessure au golf : la dissipation des forces, un accompagnement naturel et un swing conçu pour jouer toute une vie.`)
};

const vi_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vì sao Phương pháp Egly giảm nguy cơ chấn thương golf: phân tán lực, đưa gậy theo đà tự nhiên, và swing xây cho cả đời chơi.`)
};

const sw_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa nini Mbinu ya Egly inapunguza hatari ya majeraha ya gofu: kusambaza nguvu, follow-through ya asili, na swing iliyojengwa kwa ajili ya kucheza maisha yote.`)
};

const th_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำไม Egly Method จึงลดความเสี่ยงการบาดเจ็บจากกอล์ฟ: การกระจายแรง ฟอลโลว์ทรูที่เป็นธรรมชาติ และสวิงที่สร้างมาเพื่อการเล่นตลอดชีวิต`)
};

const bs_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zašto Egly Method smanjuje rizik od ozljeda u golfu: rasipanje sile, prirodni nastavak zamaha i zamah građen za cijeli život igre.`)
};

const ja_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Methodがゴルフのケガのリスクを減らす理由：力の分散、自然なフォロースルー、そして生涯プレーを続けるために作られたスイング。`)
};

const ko_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly 메서드가 골프 부상 위험을 줄이는 이유: 힘의 분산, 자연스러운 팔로스루, 그리고 평생 칠 수 있도록 만든 스윙.`)
};

const pt_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que o Egly Method reduz o risco de lesões no golfe: dissipação da força, follow-through natural e um swing feito para uma vida inteira de jogo.`)
};

const it_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché l’Egly Method riduce il rischio di infortuni nel golf: dissipazione della forza, accompagnamento naturale e uno swing costruito per giocare tutta la vita.`)
};

const sv_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varför Egly Method minskar risken för golfskador: kraftspridning, en naturlig genomsving och en sving byggd för ett helt golfliv.`)
};

const nl_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom de Egly Method het risico op golfblessures verlaagt: krachtverdeling, een natuurlijke doorzwaai en een swing die gebouwd is voor een leven lang golf.`)
};

const da_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor Egly Method mindsker risikoen for golfskader: kraftafledning, et naturligt gennemsving og et sving bygget til et helt livs spil.`)
};

const nb_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor Egly Method reduserer risikoen for golfskader: kraftfordeling, en naturlig gjennomsving og en sving bygget for et helt golfliv.`)
};

const fi_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miksi Egly Method vähentää golfvammojen riskiä: voimien hallittu vaimentaminen, luonnollinen läpivienti ja svingi, joka kestää koko pelaajauran.`)
};

const pl_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dlaczego Egly Method zmniejsza ryzyko kontuzji w golfie: rozpraszanie siły, naturalne przejście przez piłkę i swing zbudowany na całe życie gry.`)
};

const ru_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почему Egly Method снижает риск травм в гольфе: рассеивание силы, естественная проводка и свинг, рассчитанный на игру всю жизнь.`)
};

const tr_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method golf sakatlığı riskini neden azaltır: kuvvetin dağıtılması, doğal takip ve ömür boyu oynamak için kurulmuş bir swing.`)
};

const hi_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method गोल्फ़ में चोट का जोखिम क्यों घटाती है: बल का वितरण, स्वाभाविक फ़ॉलो-थ्रू और जीवन भर खेलने के लिए बना स्विंग।`)
};

const id_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa Egly Method menurunkan risiko cedera golf: penyebaran gaya, follow-through yang alami, dan ayunan yang dibangun untuk bermain seumur hidup.`)
};

const ms_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa Egly Method mengurangkan risiko kecederaan golf: penyebaran daya, ikut-lajak (follow-through) yang semula jadi dan hayunan yang dibina untuk bermain sepanjang hayat.`)
};

const cs_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proč Egly Method snižuje riziko zranění při golfu: rozptýlení síly, přirozený došvih a švih stavěný na celoživotní hru.`)
};

const el_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γιατί η Μέθοδος Egly μειώνει τον κίνδυνο τραυματισμού στο γκολφ: διάχυση της δύναμης, φυσική συνέχεια της κίνησης και ένα σβινγκ φτιαγμένο για μια ζωή στο γήπεδο.`)
};

const he_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למה Egly Method מפחיתה את הסיכון לפציעות בגולף: פיזור כוח, פולו-ת'רו טבעי וסווינג שבנוי למשחק לכל החיים.`)
};

const af_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoekom die Egly-metode gholfbeseringsrisiko verminder: verspreiding van krag, natuurlike deurvolg, en 'n swaai gebou vir 'n leeftyd van spel.`)
};

const hu_injury_meta_description = /** @type {(inputs: Injury_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miért csökkenti az Egly Method a golfsérülések kockázatát: az erő elvezetése, a természetes kilendítés és egy életre szóló játékra tervezett lendítés.`)
};

/**
* | output |
* | --- |
* | "Why the Egly Method reduces golf injury risk: dissipation of force, natural follow through, and a swing built for a lifetime of play." |
*
* @param {Injury_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_meta_description = /** @type {((inputs?: Injury_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_meta_description(inputs)
	if (locale === "de") return de_injury_meta_description(inputs)
	if (locale === "zh") return zh_injury_meta_description(inputs)
	if (locale === "ar") return ar_injury_meta_description(inputs)
	if (locale === "fr") return fr_injury_meta_description(inputs)
	if (locale === "vi") return vi_injury_meta_description(inputs)
	if (locale === "sw") return sw_injury_meta_description(inputs)
	if (locale === "th") return th_injury_meta_description(inputs)
	if (locale === "bs") return bs_injury_meta_description(inputs)
	if (locale === "ja") return ja_injury_meta_description(inputs)
	if (locale === "ko") return ko_injury_meta_description(inputs)
	if (locale === "pt") return pt_injury_meta_description(inputs)
	if (locale === "it") return it_injury_meta_description(inputs)
	if (locale === "sv") return sv_injury_meta_description(inputs)
	if (locale === "nl") return nl_injury_meta_description(inputs)
	if (locale === "da") return da_injury_meta_description(inputs)
	if (locale === "nb") return nb_injury_meta_description(inputs)
	if (locale === "fi") return fi_injury_meta_description(inputs)
	if (locale === "pl") return pl_injury_meta_description(inputs)
	if (locale === "ru") return ru_injury_meta_description(inputs)
	if (locale === "tr") return tr_injury_meta_description(inputs)
	if (locale === "hi") return hi_injury_meta_description(inputs)
	if (locale === "id") return id_injury_meta_description(inputs)
	if (locale === "ms") return ms_injury_meta_description(inputs)
	if (locale === "cs") return cs_injury_meta_description(inputs)
	if (locale === "el") return el_injury_meta_description(inputs)
	if (locale === "he") return he_injury_meta_description(inputs)
	if (locale === "af") return af_injury_meta_description(inputs)
	if (locale === "hu") return hu_injury_meta_description(inputs)
	return en_injury_meta_description(inputs)
});